<template>
    <modal name="referensiPpjk" :draggable="false" :scrollable="true" :height="'auto'">
        <div class="modal fade show " tabindex="-1" style="display: block;margin-top: 2%;" aria-modal="true" role="dialog">
            <div class="modal-dialog  modal-xl">
                <div class="modal-content">

                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"> {{ $t("ppjk") }} </h5>
                        <button type="button" class="btn btn-default" @click.prevent="removeModals()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">

                        <vue-good-table title="exim-ceisa-ppjk-list" ref="exim-ceisa-ppjk-list" mode="remote"
                            @on-page-change="onPageChangePpjk" @on-sort-change="onSortChangePpjk"
                            @on-column-filter="onColumnFilterPpjk" @on-per-page-change="onPerPageChangePpjk"
                            :totalRows="totalRecordsPpjk" :line-numbers="true" :isLoading.sync="isLoadingPpjk"
                            :pagination-options="{

                                enabled: true,
                                perPageDropdown: [10, 50, 100, 1000, 10000],
                                dropdownAllowAll: false,
                            }" :rows="rowsPpjk" :columns="columnsPpjk">



                            <template slot="table-row" slot-scope="props">
                                <span v-if="props.column.field == 'actions'">
                                    <a href="#" title="Add" @click.prevent="addDataPpjk(props.index, props.row)">
                                        <i class="mdi mdi-bookmark-plus" style="font-size:16px"></i>
                                    </a>
                                </span>
                                <span v-else>
                                    {{ props.formattedRow[props.column.field] }}
                                </span>
                            </template>
                        </vue-good-table>


                    </div>


                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-secondary" @click.prevent="removeModals()">{{
                            this.$t("close_txt") }}</button>
                    </div>


                </div>
            </div>
        </div>
    </modal>
</template>

<script>
export default {
    name: "modalReferensiPPJK",
    data() {
        return {
            serverParamsPpjk: {
                columnFilters: {},
                sort: {
                    field: "",
                    type: "",
                },
                page: 1,
                per_page: 10,
            },


            totalRecordsPpjk: 0,
            rowsPpjk: [],
            columnsPpjk: [

                {
                    label: this.$t('name'),
                    field: "nama",
                    thClass: 'text-center',
                    filterOptions: {
                            customFilter: false,
                            enabled: true, // enable filter for this column
                            placeholder: '', // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            trigger: "enter", //only trigger on enter not on keyup
                        },
                },
 

                {
                    label: this.$t('no_npwp'),
                    field: "no_npwp",
                    thClass: 'text-center',
                    filterOptions: {
                        customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: '', // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        trigger: "enter", //only trigger on enter not on keyup
                    },
                },

                
                
                {
                    label: this.$t('np_ppjk'),
                    field: "np_ppjk", 
                    filterOptions: {
                    customFilter: false,
                        enabled: true, // enable filter for this column
                        placeholder: "", // placeholder for filter input
                        filterValue: "", // initial populated value for this filter
                        filterDropdownItems: [], 
                        trigger: "enter", //only trigger on enter not on keyup
                    },

                },

                {
                    label: this.$t("action_txt"),
                    field: "actions",
                    thClass: 'text-center',
                    sortable: false,
                    filterOptions: {
                    customFilter: false,
                    }
                },

            ],

        }
    },
    methods: {
        removeModals() {
            this.$modal.hide('referensiPpjk');

        },
        addDataPpjk(index, row) {
            this.$emit("setValue", row);
            this.removeModals();
        },

        // load items pemilik barang
        loadItemsPpjk() {
            const baseURI = this.$settings.endPointCeisa + "v1/ppjk/index";
            this.isLoadingPpjk = true;

            return this.$http
                .get(
                    baseURI +
                    `?limit=${this.serverParamsPpjk.per_page}&page=${this.serverParamsPpjk.page}&sort_field=${this.serverParamsPpjk.sort.field}&sort_type=${this.serverParamsPpjk.sort.type}&np_ppjk=${this.serverParamsPpjk.columnFilters.np_ppjk}&no_npwp=${this.serverParamsPpjk.columnFilters.no_npwp}&nama=${this.serverParamsPpjk.columnFilters.nama}`,
                    { timeout: 120000 })
                .then((response) => {

                    this.isLoadingPpjk = false;
                    this.rowsPpjk = response.data.datas.data;
                    this.totalRecordsPpjk = response.data.datas.total;

                }).catch((error) => {
                    this.loading();

                    if (error.code == "ECONNABORTED") {
                        this.error(this.$t("check_internet_connection_txt"));

                    } else {

                        if (error.response) {
                            if (error.response.status === 422) {
                                this.errors = error.response.data.errors;
                                this.resultError(error.response.data.errors);
                            } else if (error.response.status === 401) {
                                this.logout();
                            } else if (error.response.status === 403) {
                                this.$router.push("/authorized-error");
                            } else if (error.response.status === 500) {
                                this.$router.push('/server-error');
                            } else {
                                this.$router.push('/page-not-found');
                            }
                        }

                    }
                });
        },

        updateParamsPpjk(newProps) {
            this.serverParamsPpjk = Object.assign({}, this.serverParamsPpjk, newProps);
            this.loadItemsPpjk();
        },

        onColumnFilterPpjk(params) {
            this.updateParamsPpjk(params);
        },

        onPageChangePpjk(params) {
            this.updateParamsPpjk({ page: params.currentPage });
        },

        onSortChangePpjk(params) {
            this.updateParamsPpjk({
                sort: {
                    type: params[0].type,
                    field: params[0].field,
                },
            });
        },

        onPerPageChangePpjk(params) {
            this.updateParamsPpjk({ per_page: params.currentPerPage });
        },
    },
    created() {
        this.loadItemsPpjk();
    }
}
</script>

<style></style>